<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Reativar mensalidade
          </h4>
        </div>
        <div class="modal-body">
          <div class="modal-body">
            <p>Observações</p>
            <input @click="errorMessage = null" class="form-input" type="text" v-model="observations">
          </div>
          <div class="modal-body">
            <div v-if="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="reactivateBill()">
            Reativar a mensalidade
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BillsService from 'services/BillsService';

export default {
  data() {
    return {
      observations: null,
      errorMessage: null,
    };
  },
  computed: {
    ...mapState([
      'selectedBill',
    ]),
  },
  methods: {
    ...mapActions([
      'loadStudentContracts',
      'loadStudentBills',
    ]),
    validate() {
      if (!this.observations) {
        this.errorMessage = 'Preencha todos os campos';
        return false;
      }
      return true;
    },
    reactivateBill() {
      if (!this.validate()) return;

      this.$loader.show();
      BillsService.reactivateBill(this.selectedBill.id, this.observations)
        .then(() => {
          Promise.all([
            this.loadStudentContracts(),
            this.loadStudentBills(),
          ]);
        })
        .then(() => this.$alert.notifySuccess('Mensalidade reativada com sucesso'))
        .catch(({ body }) => this.$alert.notifyAlert(`Erro ao reativar a mensalidade: ${body.message}`))
        .finally(() => {
          this.$emit('close');
          this.$loader.hide();
        });
    },
  },
};
</script>
